const headingStyle: React.CSSProperties = {
  margin: '18px 0 6px',
  fontSize: '14px',
  fontWeight: 700,
};

const paragraphStyle: React.CSSProperties = {
  margin: '0 0 8px',
};

const listStyle: React.CSSProperties = {
  margin: '0 0 8px',
  paddingLeft: '20px',
};

const PrivacyPolicyContent: React.FC = () => (
  <div style={{ fontSize: '13px', lineHeight: '1.6', color: '#333' }}>
    <p style={{ ...headingStyle, fontSize: '18px', margin: '0 0 6px' }}>
      Privacy Policy for Chat Assistant Plugin
    </p>
    <p style={paragraphStyle}>
      <strong>Effective Date:</strong> 01/01/2024
    </p>
    <p style={paragraphStyle}>
      Elora (&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) operates this
      Chat Assistant plugin (&quot;Service&quot;), which is based on generative
      AI and is designed to provide users with information and answers regarding
      various companies. This Privacy Policy informs you of our policies
      regarding the collection, use, and disclosure of personal data when you
      use our Service and the choices you have associated with that data. We
      value your privacy and are committed to protecting your personal
      information.
    </p>

    <p style={headingStyle}>1. Data Controller</p>
    <p style={paragraphStyle}>
      The data controller responsible for your personal information for the
      purpose of the General Data Protection Regulation (GDPR) is:
    </p>
    <p style={paragraphStyle}>
      Elora
      <br />
      42, boulevard Prince Félix
      <br />
      L-1513 Luxembourg
      <br />
      mattieu.detaille@elora.lu
    </p>

    <p style={headingStyle}>2. Types of Data Collected</p>
    <p style={paragraphStyle}>
      We collect and process the following personal data, if provided to the
      chat assistant:
    </p>
    <ul style={listStyle}>
      <li>Full Names</li>
      <li>Companies</li>
      <li>Email Addresses or Phone Numbers</li>
    </ul>

    <p style={headingStyle}>3. Purpose of Processing</p>
    <p style={paragraphStyle}>Your data is collected for the purposes of:</p>
    <ul style={listStyle}>
      <li>Enhancing the functionality and user experience of our product</li>
      <li>Conducting analytics to improve our services</li>
      <li>
        Contacting users with interest in the products or services of companies
        mentioned during the use of our Service
      </li>
    </ul>

    <p style={headingStyle}>4. Legal Basis for Processing</p>
    <p style={paragraphStyle}>
      The legal basis for processing your personal data is your explicit consent
      and, in certain cases, our legitimate interests in improving our Service
      and communications.
    </p>

    <p style={headingStyle}>5. Recipients of Data</p>
    <p style={paragraphStyle}>
      Your personal data may be shared with third-party service providers who
      assist us in operating our Service, conducting our business, or serving
      our users, so long as those parties agree to not use those data for their
      own purposes and keep this information confidential. We don&apos;t share
      your information with third parties unnecessarily.
    </p>

    <p style={headingStyle}>6. Data Transfer</p>
    <p style={paragraphStyle}>
      Your information, including Personal Data, will be stored in EU and
      won&rsquo;t be transferred outside of EU.
    </p>

    <p style={headingStyle}>7. Data Retention</p>
    <p style={paragraphStyle}>
      We will retain your personal data for 1 year or as necessary to fulfill
      the purposes outlined in this Privacy Policy.
    </p>

    <p style={headingStyle}>8. Your Rights</p>
    <p style={paragraphStyle}>
      Under GDPR, you have various rights, including:
    </p>
    <ul style={listStyle}>
      <li>
        The right to access, update or delete the information we have on you
      </li>
      <li>The right of rectification</li>
      <li>The right to object</li>
      <li>The right of restriction</li>
      <li>The right to data portability</li>
      <li>The right to withdraw consent</li>
    </ul>

    <p style={headingStyle}>9. Security of Data</p>
    <p style={paragraphStyle}>
      We are committed to protecting your data and have implemented appropriate
      technical and organizational measures designed to secure your personal
      information from accidental loss and from unauthorized access, use,
      alteration, and disclosure.
    </p>

    <p style={headingStyle}>11. Consent</p>
    <p style={paragraphStyle}>
      By using this Plugin, you consent to this policy. Users under 13 need
      parental consent.
    </p>

    <p style={headingStyle}>10. Changes to This Privacy Policy</p>
    <p style={paragraphStyle}>
      We may update our Privacy Policy from time to time. We will notify you of
      any changes by posting the new Privacy Policy on this page and updating
      the &quot;Effective Date&quot; at the top of this Privacy Policy.
    </p>

    <p style={headingStyle}>11. Contact Us</p>
    <p style={{ ...paragraphStyle, marginBottom: 0 }}>
      If you have any questions about this Privacy Policy, please contact us by
      email at mattieu.detaille@elora.lu
    </p>
  </div>
);

export default PrivacyPolicyContent;
